module.exports = __webpack_public_path__ + "static/feather-sprite-5113e3a142d01671771b4d45d027a643.svg";